module.exports = __webpack_public_path__ + "images/captchaImg_91389d7.jpg";